import { useMemo } from 'react'
import { Api } from '~/core/trpc'

type Props = {
  conversationId: string
  organizationMemberUserId?: string
}

export const useConversationParticipants = ({
  conversationId,
  organizationMemberUserId,
}: Props) => {
  const participantsQuery = Api.chatParticipant.findMany.useQuery(
    { where: { conversationId }, include: { organizationContact: true } },
    { initialData: [] },
  )

  const participantUser = useMemo(() => {
    if (organizationMemberUserId) {
      return participantsQuery.data.find(
        candidate =>
          candidate.organizationMemberId === organizationMemberUserId,
      )
    }
  }, [participantsQuery.data, organizationMemberUserId])

  const organizationContacts = useMemo(() => {
    return participantsQuery.data
      .map(participant => participant.organizationContact)
      .filter(Boolean)
  }, [participantsQuery.data])

  return {
    isReady: participantsQuery.isFetched,
    participants: participantsQuery.data,
    participantUser,
    organizationContacts,
    refetch: participantsQuery.refetch,
  }
}
